import angular from 'angular';

angular
  .module('commonServices')
  .service('enumCacheSvc', [
    '$http',
    '$q',
    'appUrls',
    'buildversion',
    'environment',
    'authService',
    enumCache,
  ]);

let _cache = {};

function enumCache($http, $q, appUrls, buildversion, environment, authService) {
  var reloadLock = null;
  var readyLock = $q.defer();
  var logLine = function(line) {
    //console.debug(line);
  };

  const tenantConfiguration = parseInt(authService.getClaims().TenantConfiguration || '1');
  const features = parseInt(authService.getClaims().WindowsSubAuthority || '0');
  const url =
    environment === 'local' ? appUrls.api + '/api/enum' : appUrls.app + '/translations/enums.json';

  var reloadEnums = function(backEndBuildVersion) {
    if (reloadLock != null) return reloadLock;
    var deferred = $q.defer();
    reloadLock = deferred.promise;
    $http
      .get(url, {
        params: {
          v: `${backEndBuildVersion};${buildversion}`,
        },
      })
      .then(
        function({ data }) {
          if (data) {
            const result = {};
            for (var e in data) {
              if (!data.hasOwnProperty(e) || e.indexOf('$') === 0) continue;
              result[e.toLowerCase()] = data[e];
            }
            _cache = result;
          }

          deferred.resolve(true);
        },
        function(error) {
          console.error('EnumCachSvc.reloadEnums:error' + JSON.stringify(error));
          deferred.reject(error);
        },
      )
      .finally(function() {
        reloadLock = null;
      });

    return reloadLock;
  };

  var init = function(backEndBuildVersion) {
    if (!readyLock || readyLock.promise.$$state.status === 1) readyLock = $q.defer(); //New ready lock
    reloadEnums(backEndBuildVersion).then(
      function() {
        readyLock.resolve(true);
      },
      function(error) {
        console.error('EnumCachSvc.init:error' + JSON.stringify(error));
        readyLock.reject(error);
      },
    );

    return readyLock.promise;
  };

  var getEnumValues = function(name, reloadOnError) {
    if (!name) return $q.resolve([]);
    logLine('IDB EnumCachSvc.getEnumValues:start');
    return readyLock.promise.then(function() {
      logLine('IDB EnumCachSvc.getEnumValues:open enums store');
      const values = _cache[name.toLowerCase()];
      if (!values) return [];
      return values.filter(
        x =>
          (!x.configs || x.configs.length === 0 || x.configs.indexOf(tenantConfiguration) >= 0) &&
          (!x.feature || (features & x.feature) > 0),
      );
    });
  };

  return {
    init: init,
    get: function(name) {
      return getEnumValues(name, true);
    },
  };
}
